'use strict';

module.exports = {
  src: require('./lib/src'),
  dest: require('./lib/dest'),
  symlink: require('./lib/symlink'),
};



//////////////////
// WEBPACK FOOTER
// ./~/vinyl-fs/index.js
// module id = 4033
// module chunks = 0